import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import PlayArrow from '@material-ui/icons/PlayArrow';
import s from './style/ViralEndVideoNavigator';
import { VIRAL_CLIP_RESOLVE_TIME } from '../../viral/constants';

const viralListItems = (clip, index, viralNextChannel, playChannel, playClip) => {
  const imageSource =
    index === 0
      ? viralNextChannel.featuredImage.replace('w=1600&h=900', 'w=800&h=450')
      : clip.thumbnail.toLowerCase().indexOf(clip.slug) > 0
      ? clip.thumbnail
      : '/assets/images/bg-sharp-1x.jpg';
  return (
    <s.viralListItemLink
      key={`viral_${clip.name}_${index}`}
      onClick={
        index !== 0
          ? () => playClip(clip._id, clip.slug)
          : () => playChannel(viralNextChannel.guideIndex)
      }
    >
      <s.viralClipImage imageURL={imageSource} />
      <s.viralPlayButton>
        {index !== 0 ? (
          <PlayArrow />
        ) : (
          <s.viralCountdown countdownTime={VIRAL_CLIP_RESOLVE_TIME}>
            <PlayArrow />
            <svg>
              <circle r="22" cx="25" cy="25" />
            </svg>
          </s.viralCountdown>
        )}
      </s.viralPlayButton>
      <s.viralClipNameWrapper>
        <s.viralClipName>{index === 0 ? '' : clip.name}</s.viralClipName>
      </s.viralClipNameWrapper>
    </s.viralListItemLink>
  );
};

class ViralEndVideoNavigatorWrapper extends PureComponent {
  static propTypes = {
    viralClips: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    viralNextChannel: PropTypes.shape({}).isRequired,
    playTVChannelAtIndex: PropTypes.func.isRequired,
    changeViralUrlSlug: PropTypes.func.isRequired,
    playViralClip: PropTypes.func.isRequired,
  };

  playClip = (id, slug) => {
    this.props.playViralClip(id, slug);
    this.props.changeViralUrlSlug(slug);
  };

  playTVChannel = (id) => {
    this.props.playTVChannelAtIndex(id);
  };

  render() {
    const { viralClips, viralNextChannel } = this.props;
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const viralClipLimit = isMobile ? 4 : 6;
    let counter = 0;
    return (
      <s.viralWrapper>
        <s.viralVideoFrame viralClips={viralClips}>
          {viralClips.map((clip, index) => {
            if (counter < viralClipLimit) {
              counter += 1;
              return viralListItems(
                clip,
                index,
                viralNextChannel,
                this.playTVChannel,
                this.playClip,
              );
            }
          })}
        </s.viralVideoFrame>
      </s.viralWrapper>
    );
  }
}

export { ViralEndVideoNavigatorWrapper };
